import React from 'react';
import { NavLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const Sidebar = () => {
  const { t } = useTranslation();

  return (
    <div className="w-64 bg-gray-800 text-white h-screen p-4 fixed">
      <h2 className="text-2xl font-bold mb-6">Task Management</h2>
      <nav>
        <ul className="space-y-2">
          <li>
            <NavLink
              to="/teams"
              className={({ isActive }) =>
                `block py-2 px-4 rounded hover:bg-gray-700 ${isActive ? 'bg-gray-700' : ''}`
              }
            >
              {t('teams')}
            </NavLink>
          </li>
          <li>
            <NavLink
              to="/add-edit-team"
              className={({ isActive }) =>
                `block py-2 px-4 rounded hover:bg-gray-700 ${isActive ? 'bg-gray-700' : ''}`
              }
            >
              {t('addEditTeam')}
            </NavLink>
          </li>
          <li>
            <NavLink
              to="/team-members"
              className={({ isActive }) =>
                `block py-2 px-4 rounded hover:bg-gray-700 ${isActive ? 'bg-gray-700' : ''}`
              }
            >
              {t('teamMembers')}
            </NavLink>
          </li>
          <li>
            <NavLink
              to="/add-edit-member"
              className={({ isActive }) =>
                `block py-2 px-4 rounded hover:bg-gray-700 ${isActive ? 'bg-gray-700' : ''}`
              }
            >
              {t('addEditMember')}
            </NavLink>
          </li>
          <li>
            <NavLink
              to="/user-page"
              className={({ isActive }) =>
                `block py-2 px-4 rounded hover:bg-gray-700 ${isActive ? 'bg-gray-700' : ''}`
              }
            >
              {t('userPage')}
            </NavLink>
          </li>
          <li>
            <NavLink
              to="/projects"
              className={({ isActive }) =>
                `block py-2 px-4 rounded hover:bg-gray-700 ${isActive ? 'bg-gray-700' : ''}`
              }
            >
              {t('projects')}
            </NavLink>
          </li>
          <li>
            <NavLink
              to="/add-edit-project"
              className={({ isActive }) =>
                `block py-2 px-4 rounded hover:bg-gray-700 ${isActive ? 'bg-gray-700' : ''}`
              }
            >
              {t('addEditProject')}
            </NavLink>
          </li>
          <li>
            <NavLink
              to="/project-details"
              className={({ isActive }) =>
                `block py-2 px-4 rounded hover:bg-gray-700 ${isActive ? 'bg-gray-700' : ''}`
              }
            >
              {t('projectDetails')}
            </NavLink>
          </li>
          <li>
            <NavLink
              to="/sub-project-details"
              className={({ isActive }) =>
                `block py-2 px-4 rounded hover:bg-gray-700 ${isActive ? 'bg-gray-700' : ''}`
              }
            >
              {t('subProjectDetails')}
            </NavLink>
          </li>
          <li>
            <NavLink
              to="/add-edit-sub-project"
              className={({ isActive }) =>
                `block py-2 px-4 rounded hover:bg-gray-700 ${isActive ? 'bg-gray-700' : ''}`
              }
            >
              {t('addEditSubProject')}
            </NavLink>
          </li>
          <li>
            <NavLink
              to="/add-edit-task"
              className={({ isActive }) =>
                `block py-2 px-4 rounded hover:bg-gray-700 ${isActive ? 'bg-gray-700' : ''}`
              }
            >
              {t('addEditTask')}
            </NavLink>
          </li>
          <li>
            <NavLink
              to="/task-details"
              className={({ isActive }) =>
                `block py-2 px-4 rounded hover:bg-gray-700 ${isActive ? 'bg-gray-700' : ''}`
              }
            >
              {t('taskDetails')}
            </NavLink>
          </li>
          <li>
            <NavLink
              to="/notifications"
              className={({ isActive }) =>
                `block py-2 px-4 rounded hover:bg-gray-700 ${isActive ? 'bg-gray-700' : ''}`
              }
            >
              {t('notifications')}
            </NavLink>
          </li>
        </ul>
      </nav>
    </div>
  );
};

export default Sidebar;